const getDisplayValue = (
  anonymous,
  manager,
  consultantValue,
  managerInfoValue
) => {
  return manager ? managerInfoValue : anonymous ? "Anonymous" : consultantValue;
};

/**
 * Get contact info (phone and email) to display with anonymous and manager overrides
 */
const getDisplayContactInfo = (
  anonymousProfile,
  managerResume,
  emailConsultant,
  emailManager,
  phoneConsultant,
  phoneManager
) => ({
  displayEmail: getDisplayValue(
    anonymousProfile,
    managerResume,
    emailConsultant,
    emailManager
  ),
  displayPhone: getDisplayValue(
    anonymousProfile,
    managerResume,
    phoneConsultant,
    phoneManager
  ),
});

export default getDisplayContactInfo;
